/**
 * React Query hook for V4 Dashboard Summary data
 */

import { useQuery } from '@tanstack/react-query'
import httpClient from 'src/utilities/http-client'
import { SummaryResponse, DashboardQueryParams } from '../types'
import { API_ENDPOINTS, buildApiUrl } from '../utils/api'

/**
 * Fetch summary data from the API
 */
async function fetchSummaryData(
  params: DashboardQueryParams,
): Promise<SummaryResponse> {
  let url = buildApiUrl(API_ENDPOINTS.SUMMARY, params)
  let response = await httpClient.get<SummaryResponse>(url)
  return response.data
}

/**
 * Hook to fetch summary data with React Query
 */
export function useSummaryData(
  params: DashboardQueryParams,
  enabled: boolean = true,
) {
  return useQuery({
    queryKey: ['dashboard-summary', params],
    queryFn: () => fetchSummaryData(params),
    enabled:
      enabled &&
      Boolean(params.linkedServiceID && params.startDate && params.endDate),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
}
